import { ContentTypeFilterValue } from '../models/ContentTypeFilterValue';
import { ChangeContentTypeAction, SearchActionTypes } from './ActionTypes';

export function changeContentType(contentTypeFilterValue: ContentTypeFilterValue): ChangeContentTypeAction {
  return {
    type: SearchActionTypes.CHANGE_CONTENT_TYPE,
    contentTypeFilterValue: contentTypeFilterValue,
  };
}
